import { render } from "./BackTop.vue?vue&type=template&id=0f5e7fd4&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"

import "./BackTop.vue?vue&type=style&index=0&id=0f5e7fd4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5e7fd4"]])

export default __exports__